<template>
  <div>
    <div class="d-flex flex-wrap gap-2 align-items-center mt-3 mb-2">
      <!-- Filtre par statut -->
      <select v-model="filters.statusFilter" class="form-select" style="max-width: 250px;">
        <option value="all">Tous les statuts</option>
        <option value="inscrit">Inscrit</option>
        <option value="absent">Absent</option>
        <option value="non-inscrit">Non inscrit</option>
      </select>

      <!-- Masquer les accompagnants -->
      <SwitchComponent v-model="filters.hideCompanions" label="Masquer les accompagnants" class="ms-1" />

      <!-- Masquer les organisateurs -->
      <SwitchComponent v-model="filters.hideOrganisateurs" label="Masquer les organisateurs" class="ms-1" />
    </div>
    <div class="d-flex flex-wrap gap-3 align-items-center pb-1">
      <button
        v-if="filters.transportFilter != 'all'"
        @click="filters.transportFilter = 'all'"
        type="button"
        class="btn btn-primary badge text-bg-info"
      >
        {{ filters.transportFilter === 'with' ? "Avec" : "Sans" }} transport uniquement
        <i class="fa fa-close ps-1" role="button"></i>
      </button>

      <button
        v-if="filters.transportOption != null"
        @click="filters.transportOption = null"
        type="button"
        class="btn btn-primary badge text-bg-info"
      >
        {{ filters.transportOption.label }} uniquement
        <i class="fa fa-close ps-1" role="button"></i>
      </button>

      <button
        v-if="filters.transfertId != null"
        @click="filters.transfertId = null"
        type="button"
        class="btn btn-primary badge text-bg-info"
      >
        {{ filters.transfertId.label }} uniquement
        <i class="fa fa-close ps-1" role="button"></i>
      </button>

      <button
        v-if="filters.hotelRoomByName != null"
        @click="filters.hotelRoomByName = null"
        type="button"
        class="btn btn-primary badge text-bg-info"
      >
        {{ filters.hotelRoomByName.label }} uniquement
        <i class="fa fa-close ps-1" role="button"></i>
      </button>

      <button type="button" class="btn btn-sm btn-link ms-auto py-0" @click="emits('resetFilters')">
        Reinitialiser les filtres
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import SwitchComponent from '@/components/common/SwitchComponent.vue'

const filters = defineModel<BoardFilters>({ required: true })

const emits = defineEmits<{
  (e: 'resetFilters'): void
}>()

</script>
